import client from './inventory-request';

// Material Groups — hierarchical master (group_code, group_name, parent_group_id, group_payload)
// API: GET /inventory/material-groups/
export const getMaterialGroups = (p) => client.get('/inventory/material-groups/', p);
// API: GET /inventory/material-groups/{id}/
export const getMaterialGroup = (id) => client.get(`/inventory/material-groups/${id}/`);
// API: POST /inventory/material-groups/
export const createMaterialGroup = (body) => client.post('/inventory/material-groups/', body);
// API: PATCH /inventory/material-groups/{id}/
export const updateMaterialGroup = (id, body) => client.patch(`/inventory/material-groups/${id}/`, body);
// API: DELETE /inventory/material-groups/{id}/
export const deleteMaterialGroup = (id) => client.delete(`/inventory/material-groups/${id}/`);
